import { Alert, Button } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { Config } from 'src/lib/config/config';
import { setOverlayVisibleLocation } from 'src/lib/routing';

export const RequestedReviewerBanner = ({
  className,
  reviewButtonDisabled,
}: {
  className?: String;
  reviewButtonDisabled?: boolean;
}) => {
  const location = useLocation();
  return (
    <Alert
      status="info"
      className={classnames(className, 'w-auto !overflow-visible p-4')}
    >
      <div className="flex w-full items-center justify-between">
        <p className="truncate text-base font-semibold">
          You've been requested as a reviewer on this proposal
        </p>
        <Tooltip
          label="Authors are not allowed to review their own proposals"
          placement="right"
          disabled={!reviewButtonDisabled}
        >
          <Button
            size="sm"
            className="ml-4"
            isDisabled={reviewButtonDisabled}
            as={Link}
            to={setOverlayVisibleLocation({
              location,
              overlayName: Config.modals.addReview,
            })}
          >
            Add review
          </Button>
        </Tooltip>
      </div>
    </Alert>
  );
};
